import {ApolloLink} from '@apollo/client';
import createSplitLinkObservable from 'src/internal/revamp/links/createSplitLinkObservable';
import {splitQueryByVariableValue} from 'src/internal/revamp/queryUtils/splitQueryByVariableValue';

import type {InternalOperation} from 'src/internal/revamp/apollo/types';
import type {TopLevelFieldsToSchemaId} from 'src/internal/revamp/config/types';
import type {SplitQueryExecution} from 'src/internal/revamp/links/createSplitLinkObservable';

export default function createVariableValueSplitLink(
  executionLink: ApolloLink,
  variableSuffix: string,
  topLevelFields: TopLevelFieldsToSchemaId['queries'],
): ApolloLink {
  const contextSplitLink = new ApolloLink(function splitQueryByContextLink(
    operation: InternalOperation,
  ) {
    const operationContext = operation.getContext();

    const subQueriesWithVariables = splitQueryByVariableValue(
      operation.query,
      operation.variables,
      variableSuffix,
      topLevelFields,
      operationContext.graphQlOperation?.type,
    );

    const executions: SplitQueryExecution[] = subQueriesWithVariables.map(
      ({subQuery, variables, containsNonNullableFields}) => {
        return {
          query: subQuery,
          link: executionLink,
          variables,
          containsNonNullableFields,
        };
      },
    );

    return createSplitLinkObservable(executions, operation);
  });

  return contextSplitLink;
}
